import React, { Component } from 'react';


class SideBar extends Component {
  renderThemes(theme, themes, current, switcher) {
    const themesList = [];

    const style = {
      icon: {color: theme.second},
      text: {color: theme.foreground}
    };

    for (const key in themes) {
      const theme = themes[key];
      themesList.push(<li key={key} onClick={() => {switcher(key)}} className={current === key ? 'side-bar__active-item' : null} style={style.text}><i style={style.icon} className="fa fa-paint-brush"></i> {theme.name}</li>);
    }

    return themesList;
  }

  render() {
    const style = {
      text: {color: this.props.theme.foreground}
    };

    return (
      <div className="side-bar">
        <div className="side-bar__title" style={style.text}>Themes</div>
        <div className="side-bar__theme-type" style={style.text}>{this.props.type}</div>
        <ul className="side-bar__themes-list">
          {this.renderThemes(this.props.theme, this.props.themes, this.props.current, this.props.switcher)}
        </ul>
      </div>
    );
  }
}

export default SideBar;



// WEBPACK FOOTER //
// ./src/components/SideBar.js